<template>

    <div class="hero" :class="{ small: small }">
        <div class="container">
            <div v-if="!fluid" class="row d-flex justify-content-center">
                <div class="col col-md-8">
                    <template v-if="$slots['default']">
                        <slot></slot>
                    </template>
                    <template v-else>
                        <h1 v-if="title" v-html="title"></h1>
                        <h2 v-if="subtitle" v-html="subtitle"></h2>
                    </template>
                </div>
            </div>
            <div v-else>
                <slot></slot>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .hero {

        background: $color-bg;
        padding: 40px 0;
        text-align: center;
        overflow: hidden;
        position: relative;

        &.small {
            h1 {
                font-size: 34px;
            }
            h2 {
                font-size: 18px;
            }
        }

        h1 {
            @include font-semibold(42px);
            color: $color-text;
            line-height: 1.2em;
            margin: 0 0 20px 0;
            padding: 0;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 30px !important;
            }
        }

        h2 {
            @include font-semibold(18px);
            color: $color-text;
            line-height: 1.6em;
            margin: 0 0 20px 0;
            padding: 0;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 16px !important;
            }
        }

        p.small {
            @include font-medium(13px);
            color: $color-text;
            padding: 0;
        }

    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        subtitle: {
            type: String,
        },
        small: {
            type: Boolean,
            default: false,
        },
        fluid: {
            type: Boolean,
            default: false,
        },
    },

}

</script>